export default {
  cards: {},
  learningResults: {},
  pagination: {},
  coreConcept: {},
};
